module.exports = __webpack_public_path__ + "img/long-arrow-white.8f64a085.svg";